import Lottie from 'lottie-react';
import { CoreDialog, CoreDialogContent, CoreTypography } from '@youscience/core';

import confettiAnimation from '../../../../assets/animations/confetti.json';

import { sxStyles, StyledText, StyledFooter } from './Confetti.styles';
import ActionButton from '@components/ActionButton';

const STYLES = {
  height: 400,
};

interface ConfettiProps {
  isShowConfetti: boolean;
  handleCloseConfetti: () => void;
  confettiStatus: string;
}

export const Confetti = (props: ConfettiProps) => {
  const { isShowConfetti, handleCloseConfetti, confettiStatus } = props;

  return (
    <CoreDialog
      data-testid="confettiWindow"
      sx={sxStyles.dialogWrap}
      open={isShowConfetti}
      onClose={handleCloseConfetti}
    >
      <CoreDialogContent sx={sxStyles.dialogContent}>
        <Lottie data-testid="confettiAnimation" animationData={confettiAnimation} loop style={STYLES} />

        <StyledText>
          <CoreTypography data-testid="confettiTitle" variant="h4" component="h3">
            Congrats!
          </CoreTypography>

          <CoreTypography data-testid="confettiSubtitle">
            {`You've completed all tasks of this ${confettiStatus}! Do you want to proceed to the next one?`}
          </CoreTypography>
        </StyledText>
      </CoreDialogContent>

      <StyledFooter>
        <ActionButton size="large" data-testid="closeBtn" onClick={handleCloseConfetti}>
          Let's go!
        </ActionButton>
      </StyledFooter>
    </CoreDialog>
  );
};
